import { Component } from '@angular/core';
import { ApiEndpoint } from 'src/app/models/settings';
import { environment } from 'src/environments/environment';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-api-dash',
  templateUrl: './api-dash.component.html',
  styleUrls: ['./api-dash.component.less']
})
export class ApiDashComponent {
  endpoints: ApiEndpoint[] = environment.apiEndpoints;
  log = '';

  constructor(private adminService: AdminService) {}

  avgDuration(durations: number[]): string {
    if (!durations.length) return 'N/A';
    const avg = durations.reduce((s, d) => s + d, 0) / durations.length;
    return avg.toFixed(0) + ' ms';
  }

  private appendLog(url: string, command: string, result: string) {
    const line = `[${url}] ${command}: ${result}`;
    this.log = this.log ? this.log + '\n' + line : line;
  }

  loadSystemInfo(url: string) {
    this.appendLog(url, 'Get System Info', 'Loading...');
    this.adminService.getSystemInfo(url).subscribe({
      next: r => this.appendLog(url, 'Get System Info', r),
      error: e => this.appendLog(url, 'Get System Info', 'Error: ' + (e.message ?? e))
    });
  }

  loadDiskSpace(url: string) {
    this.appendLog(url, 'Get Disk Space', 'Loading...');
    this.adminService.getdiskspace(url).subscribe({
      next: r => this.appendLog(url, 'Get Disk Space', r),
      error: e => this.appendLog(url, 'Get Disk Space', 'Error: ' + (e.message ?? e))
    });
  }

  doRestartApi(url: string) {
    this.appendLog(url, 'Restart API', 'Sending...');
    this.adminService.restartApi(url).subscribe({
      next: r => this.appendLog(url, 'Restart API', r),
      error: e => this.appendLog(url, 'Restart API', 'Error: ' + (e.message ?? e))
    });
  }
}
